export default __webpack_public_path__ + "static/media/games-details.173cf1cc.jpg";